<template>
  <div>

    <re-dialog :visible.sync="show" title="申请详情" width="600px">
      <el-descriptions class="margin-top" :column="1" border>
        <el-descriptions-item :label="i.label" v-for="i in showInfo" :key="i.type"
                              :labelStyle="{width:'140px'}">
          <div class="fr jsb">
            <el-tag size="mini" v-show="i.value === 0" type="primary">申请中</el-tag>
            <el-tag size="mini" v-show="i.value === 1" type="success">已通过</el-tag>
            <el-tag size="mini" v-show="i.value === -1" type="danger">需申请</el-tag>
            <el-tag size="mini" v-show="i.value === 2" type="warning">无需申请</el-tag>
            <!--              <el-button size="mini" v-show="showApplyBtn(i)" @click="applyForPermission(i)">去申请</el-button>-->
          </div>
        </el-descriptions-item>

      </el-descriptions>
      <div class="fr ac jc mt20">
        <el-button type="primary" @click="apply">一键申请</el-button>
      </div>
    </re-dialog>

    <re-dialog :visible.sync="applyCompanyDeliveryPayCheckShow" title="申请货到付款" width="500px">
      <el-form label-width="120px" size="small" class="p30" :model="param" :rules="rules" ref="deliveryPay">
        <el-form-item label="货到付款天数：" prop="day">
          <el-input v-model.number="param.day" type="number"/>
        </el-form-item>
        <el-form-item label="申请原因:" prop="apply_reason">
          <el-input v-model="param.apply_reason" type="textarea" :rows="5" resize="none"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="fr ac jc">
        <el-button @click="applyCompanyDeliveryPayCheckShow = false">取消</el-button>
        <el-button type="primary" @click="applyCompanyDeliveryPayCheck">确定</el-button>
      </div>
    </re-dialog>
    <re-dialog :visible.sync="applyFeedbackShow" :title="title" width="500px">
      <el-form label-width="120px" size="small" class="p30">

        <el-form-item label="申请原因:">
          <el-input v-model="param.remarks" :rows="5" resize="none" type="textarea"/>
        </el-form-item>
      </el-form>
      <div slot="footer" class="fr ac jc">
        <el-button @click="applyFeedbackShow = false">取消</el-button>
        <el-button type="primary" @click="remarkSubmit">确定</el-button>
      </div>
    </re-dialog>
  </div>
</template>

<script>

//反馈单下单申请
import {scoreLevel} from "@/utils/utils"

export default {
  name: "applyDetail",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    applyInfo: {
      type: Object,
      default: () => {
      }
    },
    maxDay: {
      type: Number,
      default: null
    },
    orderInfo: {
      type: Object,
      default: () => {
      }
    },
    companyInfo: {
      type: Object,
      default: () => {
      }
    },
    orderFeedbackInfo: {
      type: Array,
      default: () => []
    },
    platform_sale_receivable_ratio: {
      type: Number,
      default: null
    },
  },
  data() {
    //校验货到付款天数是否填写（排除0）
    const validator = (rule, value, callback) => {
      if (this.is_Empty(value)) {
        return callback(new Error('请输入天数'));
      }
      callback();
      return;
      if (this.is_Empty(this.$props.maxDay) || this.$props.maxDay === Infinity) return callback();
      return this.$props.maxDay < Number(value);
    }

    return {
      rules: {
        apply_reason: {required: true, message: '请输入申请原因', trigger: 'blur'},
        day: {validator: validator, required: true, trigger: 'blur'}
      },
      param: {},
      show: false,
      applyCompanyDeliveryPayCheckShow: false,
      applyFeedbackShow: false,
      title: "反馈单申请下单",
      keys: {
        isApplyRedYellowLine: "红黄线申请",
        isCashOnDeliveryApplication: "货到付款申请",
        isApplyContractClause: "合同条款申请",
        isApplyFeedback: "反馈单下单申请",
        isApplyGoods: "售价特批"
      }
    }
  },
  watch: {
    value(n) {
      this.show = n;
    },
    show(n) {
      this.$emit('input', n);
    },
  },
  computed: {
    showInfo() {
      let arr = [];
      let {applyInfo} = this.$props;
      if (this.is_Empty(applyInfo)) return arr;
      for (const applyInfoKey in applyInfo) {
        arr.push({
          label: this.keys[applyInfoKey],
          value: applyInfo[applyInfoKey],
          type: applyInfoKey
        })
      }
      return arr;
    },
    orderGoodsBeanStr() {
      let order = this.$props.orderInfo;
      if (this.is_Empty(order)) return "";
      let {orderGoodsBeans} = order;
      let str = [];
      orderGoodsBeans.forEach(el => {
        str.push(`商品名称：${el.goods_name}\n`);
        str.push(`商品型号：${el.goods_standard_name}\n`);
        str.push(`商品规格：${this.specNameInit(el, 'orderGoodsSpecificationInputBeans')}\n`);
        str.push(`商品单价：${el.goods_price}\n`)
        str.push(`商品总价：${el.goods_actual_price}\n`)
        str.push(`\n`)
      })
      return str.join('');
    },
  },

  methods: {
    apply() {
      this.show = false;
      this.$emit("apply")
    },
    showApplyBtn(i) {
      if (i.type === 'isCashOnDeliveryApplication' && i.value !== 0) return true;
      return i.value === -1;
    },
    applyForPermission(info) {
      let {type, value} = info;
      // if (value !== -1) return;
      switch (type) {
        case "isApplyRedYellowLine":
          this.applyRedLineCompanyInsertOrder();
          break;
        case "isCashOnDeliveryApplication":
          this.applyCompanyDeliveryPayCheckShow = true;
          break;
        case "isApplyContractClause":
          this.title = "合同条款填写申请"
          this.applyFeedbackShow = true;
          break;
        case "isApplyFeedback":
          this.title = "反馈单申请下单"
          this.applyFeedbackShow = true;
          break;
      }
    },
    //发起红黄线审批
    applyRedLineCompanyInsertOrder() {
      try {
        this.$confirm("您确认要发起红黄线审批吗？", "温馨提示").then(async () => {
          let {red_debt_value, yellow_debt_value, auto_credit_score} = this.$props.companyInfo;
          let {order_id, order_no, order_actual_price, company_id, company_name} = this.$props.orderInfo;


          let obj = {
            red_debt_value,
            yellow_debt_value,
            platform_sale_receivable_ratio: this.$props.platform_sale_receivable_ratio,
            auto_credit_score,
            order_goods_str: this.orderGoodsBeanStr,
            auto_credit_level: scoreLevel(auto_credit_score).level_name,
            order_id,
            order_no,
            order_actual_price: this.toDecimal2(order_actual_price),
            company_id,
            company_name,
          }
          this.post("admin/dingtalkWorkflowRecord/applyRedLineCompanyInsertOrder", obj).then(res => {
            this.$message.success("已发起申请。");
            this.$emit('success', 'isApplyRedYellowLine')
          })
        })
            .catch(() => {
              // on cancel
            });
      } catch (e) {
        console.log(e)
      }

    },
    remarkSubmit() {
      if (this.is_Empty(this.param.remarks)) {
        this.$message("请输入备注信息！");
        return;
      }
      if (this.title === "反馈单申请下单") {
        this.applyOrderFeedbackInsertOrder(this.param);
      } else {
        this.applyOrderContractClause(this.param)
      }
    },
    //合同条款申请
    applyOrderContractClause(o) {
      let order = this.$props.orderInfo
      let {order_actual_price, company_id, company_name, order_id, order_no, contract_terms} = order;


      let obj = {
        order_actual_price,
        company_id,
        order_no,
        company_name,
        order_id,
        contract_terms: JSON.parse(contract_terms)[0].content,
        order_goods_str: this.orderGoodsBeanStr,
        ...o
      };
      this.post("admin/dingtalkWorkflowRecord/applyOrderContractClause", obj).then(async (res) => {
        this.applyFeedbackShow = false;
        this.$message.success("申请已提交请等待审核通过");
        this.$emit('success', "isApplyContractClause")
        this.param = {};
      });
    },
    //反馈单下单申请
    applyOrderFeedbackInsertOrder(o) {

      let order = this.$props.orderInfo
      let {order_actual_price, company_id, company_name, order_id, order_no} = order;

      let order_feedback_str = [];
      this.orderFeedbackInfo.forEach(el => {
        order_feedback_str.push(`反馈单订单编号：${el.order_no}\n`)
        order_feedback_str.push(`商品名称：${el.goods_name} ${el.goods_standard_name}\n`)
        order_feedback_str.push('\n')
      })

      let obj = {
        order_actual_price,
        company_id,
        order_no,
        company_name,
        order_id,
        order_goods_str: this.orderGoodsBeanStr,
        order_feedback_str: order_feedback_str.join(''),
        ...o
      };
      this.post("admin/dingtalkWorkflowRecord/applyOrderFeedbackInsertOrder", obj).then(async (res) => {
        this.applyFeedbackShow = false;
        this.$message.success("申请已提交请等待审核通过");
        this.$emit('success', "isApplyFeedback")
        this.param = {};
      });
    },
    //申请货到付款
    applyCompanyDeliveryPayCheck(o) {
      this.$refs.deliveryPay.validate((valid) => {
        if (valid) {
          if (this.$props.maxDay === Number(o.day)) {
            this.$alert('当前申请的货到付款天数与之前审核通过的一致，无需申请！', '温馨提示', {
              confirmButtonText: "我知道了"
            }).then(() => {
              this.applyCompanyDeliveryPayCheckShow = false;
            });
            return;
          }
          let order = this.$props.orderInfo;
          let {order_actual_price, company_id, company_name, order_id} = order;
          let obj = {
            order_actual_price,
            company_id,
            company_name,
            order_id,
            order_goods_str: this.orderGoodsBeanStr,
            ...this.param
          };
          this.post("companyInterfaces/v1.0/applyCompanyPayOnDelivery", obj).then(async (res) => {
            this.applyCompanyDeliveryPayCheckShow = false;
            this.$message.success("申请已提交请等待审核通过");
            this.$emit('success', "isCashOnDeliveryApplication");
            this.param = {};
          });
        }
      });

    }
  }
}
</script>


// WEBPACK FOOTER //
// src/page/me/salesOrder/component/applyDetail.vue